

function updateProduct(handle) {
  fetch(`/products/${handle}.js`)
    .then(response => response.json())
    .then(product => {
      // Example: Update title, price, image, etc.
      document.querySelector('.product-title').textContent = product.title;
      document.querySelector('.product-price').textContent = Shopify.formatMoney(product.price);

      // Fetch metafields separately via Shopify AJAX API proxy (if metafields not included)
      fetch(`/products/${handle}?view=meta`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newDesc = doc.querySelector('#ProductDescription');
          if (newDesc) {
            document.querySelector('#ProductDescription').innerHTML = newDesc.innerHTML;
          }
        });
    });
}


  Fancybox.bind("[data-fancybox='product-gallery']", {
    Toolbar: {
      display: [
        { id: "zoom", position: "center" },  // zoom button
        "close"                               // close button
      ]
    },
    Image: {
      zoom: true
    },
    Carousel: {
      infinite: true
    },
    Thumbs: {
      autoStart: true
    },
    dragToClose: true,
    keyboard: {
      Escape: "close"
    }
  });


document.addEventListener("click", function (e) {
  const reviewBtn = e.target.closest(".review-rating");
  if (!reviewBtn) return;

  e.preventDefault();

  const okeTab = document.querySelector(".oke-reviewsTab");

  if (okeTab) {
    okeTab.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window
      })
    );
  }
});

